import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppComponent } from 'src/app/app.component';
import { UserDTO } from 'src/app/model/user-dto';
import { LoadIndicatorService } from 'src/app/services/load-indicator.service';
import { UserDialogComponent } from './user-dialog/user-dialog.component';
import { UserService } from 'src/app/services/user.service';
import cloneDeep from 'lodash.clonedeep';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss',
})
export class UserManagementComponent {
  public users: UserDTO[] = [];

  constructor(
    public router: Router,
    public dialog: MatDialog,
    private readonly loadIndicatorService: LoadIndicatorService,
    private readonly toastr: ToastrService,
    private readonly userService: UserService,
  ) {
    AppComponent.updateAppHeader('user management');
    this.loadUsers();
  }

  public loadUsers(): void {
    this.loadIndicatorService.show();
    this.userService
      .getUsers()
      .then((response) => {
        if (response.totalItems > 0) {
          this.users = cloneDeep(response.items);
        }
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }

  public openUserDialog(user?: UserDTO | undefined): void {
    this.dialog
      .open(UserDialogComponent, {
        data: user,
      })
      .afterClosed()
      .subscribe((response) => {
        if (response) {
          this.loadUsers();
        }
      });
  }
}
